import CitySEOHead from "@/components/feature/CitySEOHead";
import BuckheadHeroSection from "./components/HeroSection";
import BuckheadStickyNav from "./components/StickyNav";
import BuckheadProcessingTimeSection from "./components/ProcessingTimeSection";
import BuckheadServicesSection from "./components/ServicesSection";
import BuckheadLocalAreaSection from "./components/LocalAreaSection";
import BuckheadTestimonialsSection from "./components/TestimonialsSection";
import BuckheadAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import BuckheadComparisonSection from "./components/ComparisonSection";
import BuckheadMistakesSection from "./components/MistakesSection";
import BuckheadHowItWorksSection from "./components/HowItWorksSection";
import BuckheadFAQSection, { faqs } from "./components/FAQSection";
import BuckheadHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import BuckheadFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Buckhead, GA — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Buckhead, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving north Atlanta travelers. Get your emergency passport fast!";
const pageKeywords = "expedited passport, emergency passport, Buckhead passport, same day passport Atlanta, fast passport Georgia";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function BuckheadPage() {
  return (
    <>
      <CitySEOHead
        city="Buckhead"
        state="Georgia"
        stateAbbr="GA"
        route="/cities/buckhead"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Buckhead, Georgia"
        geoPosition="33.8430;-84.3660"
        keywords={pageKeywords}
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
        lastModified="2026-06-09"
        serviceAreaDesc="Fast Passport Center does not have a physical office in Buckhead — we serve this area remotely. Emergency and expedited passport services as fast as 24 hours for Buckhead and north Atlanta travelers."
      />

      <div className="font-sans">
      <BuckheadHeroSection />
      <BuckheadStickyNav />
      <BuckheadProcessingTimeSection />
      <BuckheadServicesSection />
      <BuckheadLocalAreaSection />
      <BuckheadTestimonialsSection />
      <BuckheadAcceptanceFacilitiesSection />
      <BuckheadComparisonSection />
      <BuckheadMistakesSection />
      <BuckheadHowItWorksSection />
      <BuckheadFAQSection />
      <BuckheadHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/buckhead" state="GA" />
      <BuckheadFinalCTA />
      </div>
    </>
  );
}